<template>
  <div id="{{name}}-select" class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label fill getmdl-select">
 <input class="mdl-textfield__input" v-on:blur="blur" :disabled="disabled" type="text" readonly="{{!autocomplete}}" id="{{name}}"
          tabIndex="-1" data-val="" v-model="key | label" v-on:keyup="filter">
    <label for="{{name}}">
      <i class="mdl-icon-toggle__label material-icons">keyboard_arrow_down</i>
    </label>
    <ul for="{{name}}" class="mdl-menu mdl-menu--bottom-left mdl-js-menu scrollbar">
        <li v-for="option in optionsArray" class="mdl-menu__item"
          v-on:click="selected(option)"
          data-val="{{option.value}}">
          <img v-if="img" :src="`/static/img/flags/${option.key}.svg`" style="margin-left:5px;margin-right:5px" width="20px" alt="">
          <span v-text="option.text"></span></li>
    </ul>
  </div>
</template>

<script>
var getters = require('common/store/getters')
var actions = require('common/store/actions')
var lookup = require('vue').filter('lookup')
var label = require('vue').filter('label')
var local = require('common/store/local')
module.exports = {
  ready: function () {
    var self = this
    this.optionsArray = lookup(this.options)
    this.optionsArray.forEach(o => {
      console.log(o.key)
      o.text = label(o.label)
    })
    if (this.options !== 'LANG') {
      this.optionsArray.sort((a, b) => {
        if (a.text < b.text) return -1
        else if (a.text > b.text) return 1
        else return 0
      }) } else {
      const listOrderLanguage = ['en', 'zh', 'ru', 'ja', 'ko', 'ar', 'es', 'fr', 'de', 'it']
      this.optionsArray.sort((a, b) => {
        return (
        listOrderLanguage.indexOf(a.key) - listOrderLanguage.indexOf(b.key)
    )
      })
    }
//    console.log('self.value: ' + self.value)
    this.selected(this.optionsArray.find(function (opt) {
      if (self.value) {
//        console.log('selected: ' + self.value)
        return opt.value === self.value
      } else {
        return opt.value === self.preselected
      }
    }))
  },
  props: {
    img: {
      type: Boolean,
      default: false
    },
    options: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    preselected: {
      type: String
    },
    value: {
      twoWay: true,
      required: true
    },
    autocomplete: {
      required: false,
      type: Boolean
    },
    lookupObject: {
      type: Object,
      twoWay: true
    },
    disabled: {
      required: false,
      type: Boolean
    },
    clear: {
      required: false,
      type: Boolean
    }
  },
  watch: {
    value: function (val) {
      if (!val) {
        this.key = ''
      }
    },
    preselected: function (val) {
      this.select(val)
    },
    clear: function (val) {
      if (val) {
        this.key = null
      }
    },
    disabled: function (val) {
      if (val) {
        this.optionsArray = lookup(this.options)
      }
    }
  },
  vuex: {
    local: local,
    getters: getters,
    actions: actions
  },
  methods: {
    selected: function (option) {
      if (option) {
        this.selectedKey = option.key
        this.$set('key', option.label)
        this.$set('value', option.value)
        this.$set('lookupObject', option)
        this.optionsArray = lookup(this.options)

        var mmenu = document.querySelector('#' + this.name + '-select .mdl-js-menu')
        if (mmenu.MaterialMenu == null) {
          // mdl.componentHandler.upgradeElement(mmenu)
          // mdl.componentHandler.MaterialMenu(mmenu)
          // MaterialMenu.toggle
          // MaterialMenu.componentHandler.upgradeElements()
        } else {
          mmenu.MaterialMenu.hide()
        }
      } else {
        this.$set('lookupObject', undefined)
      }
    },
    select: function (val) {
      this.selected(this.optionsArray.find(function (opt) {
        return opt.value === val
      }))
    },
    filter: function (event) {
      var text = event.target.value
      var result = lookup(this.options).filter(function (o) {
        return (label(o.label).toLowerCase().indexOf(text.toLowerCase()) > -1)
      })
      this.$set('optionsArray', result)
      var newHeight = document.querySelector('#' + this.name + '-select .mdl-menu').offsetHeight
      document.querySelector('#' + this.name + '-select .mdl-menu__container').style.height = newHeight
    },
    blur: function () {
      var self = this
      this.selected(lookup(this.options).find(function (opt) {
        return self.key && opt.value === self.key
      }))
    }
  },
  data: function () {
    return {
      key: '',
      selectedKey: '',
      optionsArray: []
    }
  }
}
</script>
<style scoped>
  .mdl-textfield {
    width: auto;
    padding: 0;
  }
  .getmdl-select .mdl-menu__container .mdl-menu {
    width:100%;
    max-height: 200px !important;
    background-color: white;
    /*border: 1px solid #f6f6f6;*/
    background-color: #f9f9f9;
  }
  .getmdl-select ul {
    overflow-y: scroll !important;
    padding-right: 17px;
  }
</style>



// WEBPACK FOOTER //
// Select.vue?e48667a8